import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
`
